export default __webpack_public_path__ + "static/media/PERSO_2.6cf8f8e4.gif";